import { useTranslations } from '@vocab/react';
import {
  Box,
  Stack,
  Inline,
  Button,
  Text,
  useToast,
} from 'braid-design-system';
import type React from 'react';

import { useMutateExpireJob } from 'src/hooks/useMutateExpireJob';

import translations from './.vocab';

interface ExpireJobFormProps {
  seekAdvertiserId: string;
  jobId: string;
  onClose(): void;
}

export const ExpireJobForm: React.FC<
  React.PropsWithChildren<ExpireJobFormProps>
> = ({ jobId, onClose }) => {
  const { t } = useTranslations(translations);
  const showToast = useToast();
  const { loading, expireJob, error } = useMutateExpireJob({ jobId });

  const onExpire = async () => {
    try {
      await expireJob();
      showToast({
        tone: 'positive',
        message: t('The job ad has been expired successfully'),
      });
      onClose();
    } catch {
      // use error from useMutation
    }
  };
  return (
    <Stack space="gutter">
      <Text>{t('This will remove it from SEEK immediately.')}</Text>
      <Text>
        {t('To re-post this ad later you will be charged for a new ad.')}
      </Text>
      <Text>{t('All other features ... work as normal.')}</Text>

      {error && (
        <Box paddingY="xsmall">
          <Text tone="critical">
            {t('...we had an issue expiring this job...')}
          </Text>
        </Box>
      )}

      <Box paddingY="xsmall">
        <Inline space="small">
          <Button
            onClick={onExpire}
            loading={loading}
            data={{ testid: 'expireJobButton' }}
          >
            {loading ? t('Expiring') : t('Expire')}
          </Button>
          <Button variant="transparent" onClick={onClose}>
            {t('Cancel')}
          </Button>
        </Inline>
      </Box>
    </Stack>
  );
};
